import { PaymentProcessorEnum } from '@systemeio/ui'
import { XenditPaymentProcessor } from 'modules/profile/payment-gateways/integrations/xendit/types'

export const xenditPaymentProcessors: XenditPaymentProcessor[] = [
  PaymentProcessorEnum.XenditID,
  PaymentProcessorEnum.XenditPH,
]
